import React from 'react';
import './Impressum.css';

const PrivacyPolicyDe = () => {
  return (
    <div className="container my-5" style={{ maxWidth: 800 }}>
      <h1 className="mb-4">Datenschutzerklärung</h1>
      <p><em>Stand: Februar 2026</em></p>

      <h2 className="mt-4">1. Einleitung</h2>
      <p>
        Die Vegbox GmbH (nachfolgend «Vegbox», «wir» oder «uns») betreibt den Onlineshop unter{' '}
        <a href="https://vegbox.ch" target="_blank" rel="noreferrer">www.vegbox.ch</a>.
        Der Schutz Ihrer Personendaten ist uns ein wichtiges Anliegen. Diese Datenschutzerklärung
        informiert Sie darüber, welche Personendaten wir erheben, wie wir sie verwenden und welche
        Rechte Sie haben.
      </p>

      <h2 className="mt-4">2. Verantwortliche Stelle</h2>
      <p>
        <strong>Vegbox GmbH</strong><br />
        Dietlikonstrasse 29, 8600 Dübendorf, Schweiz<br />
        E-Mail: <a href="mailto:vegboxgmbh@gmail.com">vegboxgmbh@gmail.com</a><br />
        Telefon: +41 78 222 42 36
      </p>

      <h2 className="mt-4">3. Welche Daten erheben wir?</h2>
      <p>Wir können folgende Personendaten erheben:</p>
      <ul>
        <li><strong>Stammdaten:</strong> Name, Adresse, E-Mail-Adresse, Telefonnummer</li>
        <li><strong>Bestelldaten:</strong> Bestellte Produkte, Lieferadresse, Lieferdatum und -zeit, Bestellhistorie</li>
        <li><strong>Zahlungsdaten:</strong> Zahlungsmittelinformationen (werden sicher über Stripe verarbeitet — wir speichern keine Kreditkartendaten)</li>
        <li><strong>Technische Daten:</strong> IP-Adresse, Browsertyp, Betriebssystem, besuchte Seiten, Zugriffszeitpunkt</li>
        <li><strong>Kommunikationsdaten:</strong> Inhalte von E-Mails oder Kontaktformularnachrichten</li>
      </ul>

      <h2 className="mt-4">4. Zu welchen Zwecken verwenden wir Ihre Daten?</h2>
      <p>Wir verwenden Ihre Personendaten zu folgenden Zwecken:</p>
      <ul>
        <li>Bearbeitung und Auslieferung Ihrer Bestellungen</li>
        <li>Kundenkommunikation (Bestellbestätigungen, Lieferupdates, Support)</li>
        <li>Zahlungsabwicklung</li>
        <li>Verbesserung unserer Website und Dienstleistungen</li>
        <li>Einhaltung gesetzlicher Pflichten</li>
      </ul>

      <h2 className="mt-4">5. Weitergabe von Daten</h2>
      <p>
        Wir geben Ihre Personendaten nur weiter, wenn dies für die Bestellabwicklung erforderlich ist:
      </p>
      <ul>
        <li><strong>Stripe:</strong> Für die sichere Zahlungsabwicklung</li>
        <li><strong>Lieferpartner:</strong> Name und Adresse für die Zustellung</li>
      </ul>
      <p>
        Wir verkaufen, handeln oder übertragen Ihre Personendaten nicht an Dritte zu Marketingzwecken.
      </p>

      <h2 className="mt-4">6. Cookies</h2>
      <p>
        Unsere Website verwendet Cookies, um die ordnungsgemässe Funktion sicherzustellen.
        Dazu gehören essenzielle Cookies für den Warenkorb und die Benutzeranmeldung.
        Es werden keine Tracking-Cookies zu Werbezwecken eingesetzt.
      </p>

      <h2 className="mt-4">7. Datensicherheit</h2>
      <p>
        Wir treffen angemessene technische und organisatorische Massnahmen, um Ihre Personendaten
        vor unberechtigtem Zugriff, Verlust oder Missbrauch zu schützen. Eine absolute Sicherheit
        der Datenübertragung im Internet können wir jedoch nicht garantieren.
      </p>

      <h2 className="mt-4">8. Aufbewahrung</h2>
      <p>
        Wir bewahren Ihre Personendaten nur so lange auf, wie es für die oben genannten Zwecke
        erforderlich ist oder wie es das Gesetz vorschreibt (z.B. buchhalterische Aufbewahrungsfristen
        von 10 Jahren). Nach Ablauf der Aufbewahrungsfristen werden die Daten gelöscht oder anonymisiert.
      </p>

      <h2 className="mt-4">9. Ihre Rechte</h2>
      <p>Sie haben folgende Rechte in Bezug auf Ihre Personendaten:</p>
      <ul>
        <li>Recht auf Auskunft über Ihre gespeicherten Daten</li>
        <li>Recht auf Berichtigung unrichtiger Daten</li>
        <li>Recht auf Löschung Ihrer Daten</li>
        <li>Recht auf Einschränkung der Datenbearbeitung</li>
        <li>Recht auf Datenübertragbarkeit</li>
      </ul>
      <p>
        Zur Ausübung Ihrer Rechte kontaktieren Sie uns bitte unter{' '}
        <a href="mailto:vegboxgmbh@gmail.com">vegboxgmbh@gmail.com</a>.
      </p>

      <h2 className="mt-4">10. Änderungen dieser Datenschutzerklärung</h2>
      <p>
        Wir können diese Datenschutzerklärung von Zeit zu Zeit anpassen. Die aktuelle Fassung
        ist jederzeit auf unserer Website einsehbar. Wir empfehlen, diese Erklärung regelmässig zu überprüfen.
      </p>

      <h2 className="mt-4">11. Kontakt</h2>
      <p>
        Bei Fragen zum Datenschutz kontaktieren Sie uns bitte:<br /><br />
        <strong>Vegbox GmbH</strong><br />
        Dietlikonstrasse 29, 8600 Dübendorf<br />
        E-Mail: <a href="mailto:vegboxgmbh@gmail.com">vegboxgmbh@gmail.com</a>
      </p>

      <p className="mt-4"><em>© 2026 Vegbox GmbH — Alle Rechte vorbehalten</em></p>
    </div>
  );
};

export default PrivacyPolicyDe;